module.exports = __webpack_public_path__ + "sounds/abc-de50f1645142b139fb346521c87e761f.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/sound/abc.mp3
// module id = 15
// module chunks = 0